import { render } from "./BlogComponent.vue?vue&type=template&id=2c856294"
import script from "./BlogComponent.vue?vue&type=script&lang=js"
export * from "./BlogComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__